module.exports = __webpack_public_path__ + "img/shape_tracerstudy_end.0ccab2be.svg";